var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "panel-group", attrs: { gutter: 40 } },
    [
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 6 } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function($event) {
                  return _vm.handleSetLineChartData("newVisitis")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-people" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "TEU",
                      "class-name": "card-panel-icon"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" 今日货量（票） ")
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: { "start-val": 0, "end-val": 104, duration: 1200 }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 6 } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function($event) {
                  return _vm.handleSetLineChartData("messages")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-message" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "message",
                      "class-name": "card-panel-icon"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" 内部消息 ")
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: { "start-val": 0, "end-val": 127, duration: 1400 }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 6 } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function($event) {
                  return _vm.handleSetLineChartData("purchases")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-money" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "money",
                      "class-name": "card-panel-icon"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" 超期欠款 ")
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: { "start-val": 0, "end-val": 4252000, duration: 960 }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { xs: 12, sm: 12, lg: 6 } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function($event) {
                  return _vm.handleSetLineChartData("shoppings")
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-shopping" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "peoples",
                      "class-name": "card-panel-icon"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v(" 本月新增客户 ")
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: { "start-val": 0, "end-val": 25, duration: 260 }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }